import React from 'react'
import { Link } from 'react-router-dom'
import Constant, { getCountryTimeZone } from '../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import axios from 'axios'
// import Moment from 'react-moment'
import Loader from '../../common/Loader'
import CustomFooter from '../../common/TableBottom'
import moment from 'moment'
import { withTranslation } from 'react-i18next'
import momentTz from 'moment-timezone'

class EventBooking extends React.Component {
  state = {
    country_list: [],
    Booking_data: [],
    users_data: [],
    model: false,
    limit: 100,
    pageNumber: 0,
    disabled: false,
    keyword: '',
    bookingStatus: '',
    country: '',
    cruiseId: '',
    cruiseList: [],
    nationality: [],
    nationalityId: '',
    type_tag: '',
    booking_date: moment().format('YYYY-MM-DD'),
    customer_phone: null,
    isSearching: false,
    isCancelled: false,
    listHourFormat: 'today',
    buttonDisabled: false,
  }

  debounceTimeout = null
  currentLanguage = 'en'

  componentDidMount() {
    // Call the function once when the component mounts
    this.getBookingList()

    // Call the function every 1 minutes
    this.interval = setInterval(
      () => {
        this.setState({ Booking_data: [] })
        this.getBookingList()
      },
      1 * 60 * 1000
    ) // 1 minutes in milliseconds
  }

  getBookingList = async () => {
    this.setState({
      isSearching: true,
      Booking_data: [],
    })
    await axios
      .get(Constant.getAPI() + `/admin/port-admin/event-bookings`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          status: this.state.bookingStatus,
          keyword: this.state.keyword,
          pageNumber: this.state.pageNumber,
          limit: this.state.limit,
          listHourFormat: this.state.listHourFormat,
        },
      })
      .then((res) => {
        if (res.data.success) {
          res.data.data.forEach((booking) => {
            if (booking.booking_status == 'Cancelled' || booking.booking_cancel) {
              booking.booking_status = 'Cancelled'
            } else if (booking.booking_status == 'Postponed') {
              booking.booking_status = 'Postponed'
            } else if (booking.booking_status == 'Confirmed') {
              booking.booking_status = 'Confirmed'
            } else if (booking.booking_status == 'Successful') {
              booking.booking_status = 'Successful'
            } else if (booking.booking_status == 'Pending' && booking.payment_status == true) {
              booking.booking_status = 'Pending'
            } else if (booking.booking_status == 'Sailed') {
              booking.booking_status = 'Sailed'
            } else {
              booking.booking_status = 'Pending'
            }

            booking.isTodaysBooking =
              momentTz(booking.orderPlacedDate)
                .tz(getCountryTimeZone(localStorage.getItem('countryShortName')))
                .format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')
          })

          this.setState({
            Booking_data: res.data.data,
            disabled: !Object.keys(res.data?.pagination?.next || {}).length > 0,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isSearching: false,
        })
      })
  }

  handleChange = (event) => {
    event.persist()
    this.setState(
      {
        [event?.target?.name]: event?.target?.value,
      },
      () => {
        if (event?.target?.name == 'listHourFormat') {
          this.getBookingList()
        }

        if (event?.target?.name == 'bookingStatus') {
          this.getBookingList()
        }
      }
    )

    if (event?.target?.name == 'country') {
      this.setState({
        cruiseList: [],
        cruiseId: '',
      })
      if (event.target.value != '') {
        this.getCruiseList(event.target.value)
      }
    }
  }

  markAsSailed = async (rowData) => {
    this.setState({ buttonDisabled: true })
    let id = rowData[0]
    let data = {}
    let temp_data = this.state.Booking_data
    temp_data.forEach((itm) => {
      if (itm.order_number == id) {
        data.booking_id = itm.id
      }
    })

    data['booking_status'] = 'Sailed'
    await axios
      .post(Constant?.getAPI() + `/booking/sail-cruise`, data, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data.success) {
          Swal.fire('Updated !', 'Cruise details Updated', 'success')
          this.getBookingList()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({ buttonDisabled: false })
      })
  }

  getCruiseList = async (country = '') => {
    await axios
      .get(Constant.getAPI() + '/cruise/list-cruise', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name:
            localStorage.getItem('loged_In_role') === 'super-admin'
              ? ''
              : `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          country: country,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            cruiseList: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  searchData = async () => {
    this.setState(
      {
        limit: 100,
        pageNumber: 0,
      },
      () => {
        this.getBookingList()
      }
    )
  }

  clearFilters = () => {
    this.setState(
      {
        cruiseId: '',
        country: '',
        type_tag: '',
        bookingStatus: '',
        nationalityId: '',
        booking_date: '',
        customer_phone: '',
        keyword: '',

        limit: 100,
        pageNumber: 0,

        Booking_data: [],
      },
      () => {
        this.getBookingList()
      }
    )
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.searchData()
    }
  }

  render() {
    const { i18n } = this.props
    const currentLanguage = i18n.language
    const isArabic = currentLanguage === 'ar'
    const tableDirection = isArabic ? 'rtl' : 'ltr'
    const textAlign = isArabic ? 'right' : 'left'

    const customToolbar = () => {
      return (
        <>
          <div className="row">
            <div
              className="col-md-12"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                direction: tableDirection,
                position: 'relative',
                padding: '10px 0',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '20px',
                  order: isArabic ? 1 : 2,
                  margin: isArabic ? '0 0 0 auto' : '0 auto 0 0',
                }}
              >
                <img
                  class="blinking-icon"
                  src="/assets/images/live.png"
                  alt="live"
                  style={{
                    width: '100px',
                    objectFit: 'contain',
                  }}
                />
                <label style={{ fontWeight: 'bold' }}>{'Upcomming Bookings of'}</label>
                <select
                  name="listHourFormat"
                  className="form-control"
                  value={this.state.listHourFormat}
                  onChange={this.handleChange}
                  style={{ width: '150px' }}
                >
                  <option value={'today'}>{this.props.t('today')}</option>
                  <option value={'D'}>24 {this.props.t('hours')}</option>
                  <option value={'H'}>1 {this.props.t('hour')}</option>
                </select>
              </div>
            </div>
          </div>
        </>
      )
    }

    const columns = [
      {
        name: 'serial_number',
        label: this.props.t('serialNumber'),
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap', textAlign }}>{value}</div> : '--'),
        },
      },
      {
        name: 'isTodaysBooking',
        label: 'isTodaysBooking',
        options: {
          filter: true,
          sort: true,
          display: false,
        },
      },
      {
        name: 'order_number',
        label: this.props.t('orderNo'),
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap', textAlign }}>{value}</div> : '--'),
        },
      },
      {
        name: currentLanguage === 'en' ? 'event_name_en' : 'event_name_ar',
        label: this.props.t('eventName'),
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap', textAlign }}>{value}</div> : '--'),
        },
      },
      {
        name: 'start_time',
        label: this.props.t('startTime'),
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <div style={{ width: 80, textAlign }}>{value}</div>
          },
        },
      },
      {
        name: 'end_time',
        label: this.props.t('endTime'),
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <div style={{ width: 80, textAlign }}>{value}</div>
          },
        },
      },
      {
        name: 'booking_date',
        label: this.props.t('bookingDate'),
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <div style={{ width: 80, textAlign }}>{value}</div>
          },
        },
      },
      {
        name: 'additional_items_available',
        label: this.props.t('preparations'),
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => (
            <div style={{ textAlign: 'center' }}>
              {value ? (
                <img
                  src="assets/images/delivery-man.png"
                  alt="Delivery Man"
                  style={{ width: '40px' }}
                />
              ) : (
                '--'
              )}
            </div>
          ),
        },
      },
      {
        name: currentLanguage === 'en' ? 'customer_name' : 'customer_name_ar',
        label: this.props.t('customerName'),
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) =>
            value !== ' ' ? <div style={{ textWrap: 'nowrap', textAlign }}>{value}</div> : 'Guest User',
        },
      },
      {
        name: 'type_tag',
        label: this.props.t('typeTag'),
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => <div style={{ textAlign }}>{value}</div>,
        },
      },
      {
        name: 'booking_status',
        label: this.props.t('bookingStatus'),
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value) => {
            let statusStyle = {}

            if (value === 'Cancelled' || value === 'Booking Cancel') {
              statusStyle = { backgroundColor: 'red', color: 'white', fontWeight: 'bold' }
            } else if (value === 'Postponed') {
              statusStyle = { backgroundColor: '#f4c2c2', color: 'black', fontWeight: 'bold' }
            } else if (value === 'Confirmed') {
              statusStyle = { backgroundColor: '#98fb98', color: 'black', fontWeight: 'bold' }
            } else if (value === 'Pending') {
              statusStyle = { backgroundColor: '#add8e6', color: 'black', fontWeight: 'bold' }
            } else if (value === 'Sailed') {
              statusStyle = { backgroundColor: '#00bfff', color: 'white', fontWeight: 'bold' }
            } else if (value === 'Successful') {
              statusStyle = { backgroundColor: '#0ac282', color: 'black', fontWeight: 'bold' }
            } else {
              statusStyle = { backgroundColor: 'gray', color: 'white', fontWeight: 'bold' }
            }
            return value ? (
              <div style={{ textAlign }}>
                <span
                  className="badge badge-pill"
                  style={statusStyle}
                >
                  {this.props.t(value)}
                </span>
              </div>
            ) : (
              '--'
            )
          },
        },
      },
      {
        name: 'booking_status',
        label: this.props.t('sail'),
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, { rowData }) => {
            return (
              <div style={{ textAlign }}>
                {value === 'Sailed' ? (
                  <button
                    className="btn btn-primary"
                    style={{ padding: '5px 10px', borderRadius: '5px' }}
                    disabled
                  >
                    {this.props.t('Sailed')}
                  </button>
                ) : (
                  <button
                    onClick={() => this.markAsSailed(rowData)}
                    className="btn btn-danger"
                    style={{ padding: '5px 10px', borderRadius: '5px' }}
                    disabled={this.state.buttonDisabled}
                  >
                    {this.props.t('Mark as Sailed')}
                  </button>
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'booking_cancel_from',
        label: 'Cancel From',
        options: {
          filter: false,
          sort: false,
          display: this.state.bookingStatus == 'Cancelled',
          customBodyRender: (value) => {
            return (
              <span style={{ textTransform: 'capitalize', textAlign }}>
                {value == 'system' ? 'Auto cancel' : value || '--'}
              </span>
            )
          },
        },
      },
      {
        name: 'id',
        label: this.props.t('view'),
        options: {
          filter: false,
          sort: true,
          customBodyRender: (booking_id) => {
            return (
              <div style={{ textAlign }}>
                <Link
                  to={'/event-booking-details/' + booking_id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="View "
                >
                  <i className="f-22 icofont icofont-eye text-dark"></i>
                </Link>
              </div>
            )
          },
        },
      },
    ]

    const options = {
      viewColumns: false,
      print: false,
      download: false,
      search: false,
      filter: false,
      rowsPerPage: 100,
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            count={this.state.limit}
            pageNumber={this.state.pageNumber}
          />
        )
      },

      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
          },
          () => {
            this.getBookingList()
          }
        )
      },

      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
          },
          () => {
            this.getBookingList()
          }
        )
      },

      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSearching ? (
            <Loader open={this.state.isSearching} />
          ) : (
            this.props.t('Sorry, No Booking Data Found')
          ),
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
      setTableProps: () => ({
        dir: tableDirection,
        style: { direction: tableDirection },
      }),
      setHeadCellProps: () => ({
        style: { textAlign },
      }),
      setCellProps: () => ({
        style: { textAlign },
      }),
      setRowProps: (rowData) => {
        return rowData[1] ? { className: 'blink-border' } : { style: { backgroundColor: 'white' } }
      },
    }

    return (
      <>
        <div className="page-body">
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-border-default">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4 col-sm-12">
                      <div className="form-group row">
                        <label className="col-4 col-form-label">{this.props.t('search')}</label>
                        <div className="col-8">
                          <input
                            type="text"
                            id="keyword"
                            className="form-control"
                            value={this.state.keyword}
                            name="keyword"
                            placeholder={`${this.props.t('orderNo')} | ${this.props.t('eventName')} | ${this.props.t('customerName')}`}
                            onKeyPress={this.handleKeyPress}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-12">
                      <div className="form-group row">
                        <label className="col-4 col-form-label">{this.props.t('bookingStatus')}</label>
                        <div className="col-8">
                          <select
                            name="bookingStatus"
                            className="form-control"
                            value={this.state.bookingStatus}
                            onChange={this.handleChange}
                          >
                            <option value={''}>{this.props.t('all')}</option>
                            <option value={'Pending'}>{this.props.t('Pending')}</option>
                            <option value={'Successful'}>{this.props.t('Successful')}</option>
                            <option value={'Cancelled'}>{this.props.t('Cancelled')}</option>
                            <option value={'Confirmed'}>{this.props.t('Confirmed')}</option>
                            <option value={'Postponed'}>{this.props.t('Postponed')}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      {this.state.isSearching ? (
                        <button
                          className="btn btn-sm btn-grd-disabled"
                          disabled
                          style={{ width: 150 }}
                        >
                          {this.props.t('searching')}
                        </button>
                      ) : (
                        <button
                          style={{ width: 150 }}
                          onClick={this.searchData}
                          className="btn btn-sm btn-inverse waves-effect"
                        >
                          {this.props.t('search')}
                        </button>
                      )}
                      <button
                        style={{ width: 150, marginLeft: 10 }}
                        onClick={this.clearFilters}
                        className="btn btn-sm btn-inverse waves-effect"
                      >
                        {this.props.t('clear')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page-body">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-block">
                  <div className="dt-responsive table-responsive">
                    <MUIDataTable
                      title={customToolbar()}
                      className="table-responsive"
                      data={this.state.Booking_data}
                      columns={columns}
                      options={options}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default withTranslation()(EventBooking)
